import { JobsSection, Section, type Jobs } from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import { Bleed } from 'braid-design-system';
import type { SalariesTabModel } from '../../../pages/salaries/salariesTabModel';
import translations from './.vocab/index';

interface OpenJobsSectionProps {
  getPaginatedJobs: (organisationId: string, page?: number) => Promise<Jobs>;
  model: Pick<SalariesTabModel, 'jobs'>;
  trackJobsPaginationClicked: ({
    searchTotalCount,
    pageNumber,
  }: {
    pageNumber: number;
    searchTotalCount?: number;
  }) => void;
}

export const OpenJobsSection = ({
  model,
  getPaginatedJobs,
  trackJobsPaginationClicked,
}: OpenJobsSectionProps) => {
  const { jobs } = model;
  const { t } = useTranslations(translations);
  return (
    <Section mode={'view'} heading={t('Open jobs')} padding={'none'}>
      <Bleed horizontal={['none', 'none', 'large']}>
        <JobsSection
          mode="view"
          model={jobs}
          getPaginatedJobs={getPaginatedJobs}
          trackJobsPaginationClicked={trackJobsPaginationClicked}
        />
      </Bleed>
    </Section>
  );
};
